import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLayerGroup } from '@react-icons/all-files/fa/FaLayerGroup';
import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import ProfaseModal from '../../commons/ProfaseModal';
import ProfaseDataGrid from '../../commons/Datagrid';
import Confirm, { useConfirm } from '../../commons/Confirm';
import PageAlert, { usePageAlert } from '../../commons/PageAlert';
import { DeleteButton, EditButton, RenderActions } from '../../commons/DataGridActions';
import { useAppDispatch, useAppSelector } from '../../store';
import { deleteEntity, getEntities, reset } from '../../manager/workflow-clase.reducer';

export default function WorkflowClasesModal() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const entities      = useAppSelector(s => s.workflowClase.entities);
  const totalItems    = useAppSelector(s => s.workflowClase.totalItems);
  const loading       = useAppSelector(s => s.workflowClase.loading);
  const updating      = useAppSelector(s => s.workflowClase.updating);
  const updateSuccess = useAppSelector(s => s.workflowClase.updateSuccess);

  const [rows, setRows]             = useState<any[]>([]);
  const [lastParams, setLastParams] = useState<any>(null);

  const { alert, showToast } = usePageAlert();
  const { confirmConfig, ask, dismiss, setConfirmLoading } = useConfirm();

  useEffect(() => { setRows(entities ?? []); }, [entities]);

  useEffect(() => {
    if (updateSuccess) {
      dispatch(reset());
      dismiss();
      if (lastParams) dispatch(getEntities(lastParams));
      showToast('success', 'Clase eliminada correctamente.');
    }
  }, [updateSuccess, dispatch, lastParams, dismiss, showToast]);

  useEffect(() => {
    setConfirmLoading(updating);
  }, [updating, setConfirmLoading]);

  const fetchData = (params: any) => {
    setLastParams(params);
    dispatch(getEntities(params));
  };

  const renderActions = (params: any) => (
    <RenderActions>
      <EditButton onClick={() => navigate(`/workflow/clases/${params.row.id}`)} />
      <DeleteButton onClick={() => {
        ask(
          <>¿Confirmas que deseas eliminar <strong>{params.row.nombre}</strong>? Esta acción no se puede deshacer.</>,
          () => dispatch(deleteEntity(params.row.id)),
          { title: 'Eliminar Clase', confirmLabel: 'Eliminar', variant: 'danger' },
        );
      }} />
    </RenderActions>
  );

  const cols = [
    { field: 'id',     headerName: 'ID',     flex: 0.4 },
    { field: 'nombre', headerName: 'Nombre', flex: 1.5 },
    {
      field: '__actions',
      headerName: '',
      flex: 0.8,
      filterable: false,
      renderCell: renderActions,
    },
  ];

  const filters = [
    { label: 'Nombre', name: 'nombre' },
  ];

  const close = () => navigate('/workflow');

  return (
    <ProfaseModal
      open
      titleId="workflow-clases-modal-title"
      size="xlarge"
      scroll
    >
      <div style={s.header}>
        <h2 id="workflow-clases-modal-title" className="profase-modal-title m-0">
          <FaLayerGroup style={{ marginRight: 8, verticalAlign: '-2px' }} />
          Clases de Workflow
        </h2>
        <div style={s.actions}>
          <button
            type="button"
            className="btn btn-sm btn-light d-inline-flex align-items-center justify-content-center"
            style={s.plusBtn}
            title="Nueva clase"
            aria-label="Nueva clase"
            onClick={() => navigate('/workflow/clases/new')}
          >
            <FaPlus />
          </button>
          <button type="button" className="profase-form-btn-secondary btn-sm" onClick={close}>
            Cerrar
          </button>
        </div>
      </div>

      <Confirm config={confirmConfig} />
      {alert && <PageAlert alert={alert} />}

      <ProfaseDataGrid
        cols={cols}
        title=""
        filters={filters}
        fetch={fetchData}
        rowCount={totalItems}
        loading={loading}
        rows={rows}
      />
    </ProfaseModal>
  );
}

const s: Record<string, React.CSSProperties> = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 16,
    flexWrap: 'wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  plusBtn: {
    width: 36,
    height: 32,
    padding: 0,
  },
};
